module.exports = __webpack_public_path__ + "media/images/expand_close_icon-830f01a86a14c8c272996282253cc6c5.png";